import { HStack } from "@chakra-ui/react"
import CountCard from "../../../components/countCard/CountCard";


const CountSection = ({count = 0, title = "Total Users"}) => {
    return (
        <HStack justifyContent="flex-start" alignItems="center" mb={4} spacing={4}>
            <CountCard text={title} count={count} />
        </HStack>
    )
}
export default CountSection;